import type { API } from '@/types/typings';

// 这里只保留试用逻辑真正需要的环境字段，避免把整个 envInfo 传进来导致判断语义变乱。
type VersionTrialEnvInfo = {
  envSuccess?: string;
  iyb?: string;
};

// 平台管理员的登录态不走用户端试用流程，避免把平台账号误请求到用户企业接口。
export const isPlatformAdminUser = (currentUser?: API.CurrentUser) => {
  return currentUser?.enterpriseId === 1 || currentUser?.enterpriseCode === 'platform';
};

/*
 * 判断当前上下文是否允许调用用户端试用接口：
 * 1. 必须有企业信息；
 * 2. 不能是平台管理员；
 * 3. 企业环境必须已正常开通；
 * 4. 不能是 IYB/平台类环境。
 */
export const canUseCustomerVersionTrialApi = (
  currentUser?: API.CurrentUser,
  envInfo?: VersionTrialEnvInfo,
) => {
  if (!currentUser?.enterpriseId || !currentUser?.enterpriseCode) {
    return false;
  }

  if (isPlatformAdminUser(currentUser)) {
    return false;
  }

  if (envInfo?.envSuccess && envInfo.envSuccess !== 'Y') {
    return false;
  }

  if (envInfo?.iyb === 'Y') {
    return false;
  }

  return true;
};
